const ValidationType = {
	NumberGreaterThanZero : "NumberGreaterThanZero",	
	NumberGreaterThanZeroOrZero : "NumberGreaterThanZeroOrZero",
	NumberGreaterThanZeroOrZeroOrEmpty : "NumberGreaterThanZeroOrZeroOrEmpty",
	MandatoryText : "MandatoryText",
  }

 export default ValidationType;